import colors from 'styles/colors'

export function getColor(percent) {
  if (percent >= 90) {
    return colors['color-orange']
  } else {
    return colors['color-green']
  }
}

export function getSeatColor(percent) {
  if (percent > 100) {
    return colors['color-orange']
  } else {
    return colors['color-green']
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalNotificationBar/helpers.js